import { Entry } from '@b2ag/contentful'

export const isNonNullableEntryDTO = <T extends Entry>(dto?: T): dto is NonNullable<T> => Boolean(dto?.fields)
